import { useEffect } from "react";
import Cookies from 'js-cookie';
import { useLogout } from "services/logout";
import { useRouter } from "common/hooks/useRouter";
import { getDomain, handleProductType } from "common/method/helper";
import { useSearchParams } from "react-router-dom";


export const Logout = () => {
	const { mutateAsync } = useLogout()
	const { navigate } = useRouter()

	const [searchParams] = useSearchParams();



	const logoutUser = async () => {

		try {
			const client_id = Cookies.get('client_id');
			let res;

			if (client_id) {
				res = await mutateAsync({ token: client_id, pt: handleProductType(searchParams) })
				Cookies.remove('client_id', { path: "/", domain: getDomain() });
			}
			if (res?.result) {
				window.location.href = res.result
			} else {
				navigate.pushLogin()
			}
		} catch {
			navigate.pushLogin()
		}

		// dispatch(setAuthorizedUser(false));
	};

	useEffect(() => {
		logoutUser();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null
}
